module.exports = __webpack_public_path__ + "img/icon58.32a04442.png";